import React from 'react';
import about from '../assests/img/about-home.jpeg';


import img1 from '../assests/img/general-cat-bg.png';
import img2 from '../assests/img/catloge-bg-03.jpg';
import img3 from '../assests/img/catloge-bg-04.png';


import pdf1 from '../assests/img/pdf/general-catalogue.pdf';
import pdf2 from '../assests/img/pdf/catalogue-laboratory-plasticware.pdf';
import pdf3 from '../assests/img/pdf/anatomical-models.pdf';






function Showact() {
  return (
    <>
     
      <section className="show-activity">

        <div className='sec-title'>
          <h2>Explore Our Catalogues</h2>
          <h4>We have a variety of products. You can choose the categories to explore the products of your choice.</h4>
          <div class="separator"></div>
        </div>

        <div className="container">
          <div className="row-inner">
            <div className='col-md-12 inner-view-gallery-box'>
            <div className='gallery-box'>
              <a href={pdf1} target="_blank">
              <img src={img1}/>
              <h2>General Catalogue</h2>
              </a>
            </div>
            <div className='gallery-box'>
               <a href={pdf2} target="_blank">
              <img src={img2}/>
              <h2>Laboratory Plasitcware</h2>
              </a>
            </div>
            <div className='gallery-box'>
               <a href={pdf3} target="_blank">
              <img src={img3}/>
              <h2>Anatomical Models</h2>
              </a>
            </div>                  
            </div>

           
          </div>
        </div>
      </section>

    </>
  )

}

export default Showact;
